import { gql } from '@apollo/client';

export const RESOURCE_REGION_MAPPING_FIELDS = gql`
    fragment ResourceRegionMappingFields on resource_region_mappings {
        mapping_id
        resource_id
        subregion_id
    }
`;
